/**
 * Simply Drop (K6.5): Kerninhaltsstoff-Karten variantengerecht umschalten, ohne die
 * Seite neu zu laden. Die Ausgangslage stimmt bereits serverseitig (sd-ingredients.liquid
 * blendet die passenden Karten fuer die vorausgewaehlte Variante direkt aus), dieses
 * Skript reagiert nur auf spaetere Variantenwechsel.
 *
 * Hakt sich in das oeffentliche Prestige-Event "variant:change" ein (wird von
 * variant-picker.js auf dem Produktformular ausgeloest, bubbled bis document). Fasst
 * snippets/sd-variant-picker.liquid dafuer bewusst nicht an.
 *
 * Erwartete Markup-Vertraege (aus snippets/sd-ingredients.liquid):
 *   <div class="sd-ing" data-karten-variante='{"Optionswert":["karten-handle", ...]}'>
 *     <li class="sd-ing__item" data-ki-handle="karten-handle">...</li>
 */
(function () {
  'use strict';

  function ausblendListe(container, karte, verstecken) {
    if (verstecken) {
      karte.setAttribute('hidden', '');
    } else {
      karte.removeAttribute('hidden');
    }
  }

  function wende(container, variant) {
    if (!variant) return;

    var rohdaten = container.getAttribute('data-karten-variante');
    if (!rohdaten) return;

    var zuordnung;
    try {
      zuordnung = JSON.parse(rohdaten);
    } catch (e) {
      return;
    }

    var optionswerte = [variant.option1, variant.option2, variant.option3].filter(Boolean);
    var versteckteHandles = [];

    for (var i = 0; i < optionswerte.length; i++) {
      var treffer = zuordnung[optionswerte[i]];
      if (treffer) {
        versteckteHandles = treffer;
        break;
      }
    }

    var karten = container.querySelectorAll('[data-ki-handle]');
    var sichtbar = 0;
    for (var k = 0; k < karten.length; k++) {
      var handle = karten[k].getAttribute('data-ki-handle');
      var weg = versteckteHandles.indexOf(handle) !== -1;
      ausblendListe(container, karten[k], weg);
      if (!weg) sichtbar++;
    }
    // C6: Zahl in der Einleitung ("3 Kerninhaltsstoffe") zeigt immer die sichtbaren Karten
    var zahl = container.querySelector('[data-ki-zahl]');
    var wort = container.querySelector('[data-ki-wort]');
    if (zahl) zahl.textContent = sichtbar;
    // Woerter aus den Locale-Dateien (sd.ingredients.key_singular/key_plural), als data-ki-* gerendert.
    if (wort) wort.textContent = (sichtbar === 1 ? wort.getAttribute('data-ki-singular') : wort.getAttribute('data-ki-plural')) || wort.textContent;
  }

  /* C6: FAQ-Fragen je Füllung. custom.faq_je_variante (JSON Optionswert -> Textstücke der
     auszublendenden Fragen, z. B. {"Badepulver":["Alpensalz"]}) landet als data-faq-variante am
     .sd-faq (snippets/sd-faq.liquid). */
  function faqAnwenden(variant) {
    var faq = document.querySelector('.sd-faq[data-faq-variante]');
    if (!faq || !variant) return;
    var zuordnung;
    try { zuordnung = JSON.parse(faq.getAttribute('data-faq-variante')); } catch (e) { return; }
    var werte = [variant.option1, variant.option2, variant.option3].filter(Boolean);
    var teile = [];
    for (var i = 0; i < werte.length; i++) { if (zuordnung[werte[i]]) { teile = zuordnung[werte[i]]; break; } }
    var fragen = faq.querySelectorAll('.sd-faq__item');
    for (var f = 0; f < fragen.length; f++) {
      var text = (fragen[f].querySelector('summary') || {}).textContent || '';
      var weg = teile.some(function (t) { return text.indexOf(t) !== -1; });
      if (weg) { fragen[f].setAttribute('hidden', ''); } else { fragen[f].removeAttribute('hidden'); }
    }
  }

  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;

    faqAnwenden(variant);
    var container = document.querySelector('.sd-ing[data-karten-variante]');
    if (!container) return;

    wende(container, variant);
  });
})();
